import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../../components/Cards/Card";
import KpiCard from "../../../components/KpiCard/KpiCard";

const SellThruEucerinCard = ({ app }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card
        app={app}
        className={"card-kpi-item"}
        key="FATURAMENTO_SELL_THRU_EUCERIN"
        header={{ hardTitle: "Sell Thru Eucerin" }}
      >
        <KpiCard
          styles={{ boxShadow: "none" }}
          app={app}
          valueId={"BUQsvM"}
          goalValueId={"zgFgju"}
          percentageId={"zwJvjs"}
          hasProgressBar={true}
          fullView
        />
      </Card>
    </Grid>
  );
};

SellThruEucerinCard.propTypes = {
  app: PropTypes.object.isRequired,
};

export default SellThruEucerinCard;
